const itemsOnDisplayInSlider = slider => {
  const { props = {}, state = {} } = slider || {}
  const { itemsPerSlide = 0, currentIndex = 0 } = state
  const { items = [] } = props
  const startIndex = Math.max((currentIndex - 1) * itemsPerSlide, 0)
  const endIndex = currentIndex * itemsPerSlide
  const displayedList = items.slice(startIndex, endIndex)
  return displayedList
}

export default itemsOnDisplayInSlider
